if ($('#js-allMarketsContent').length !== 0) {

    module.exports = {
        init: function () {
            var self = this;

            self.businessContent = $('#js-allMarketsContent');

            self.btnYes = $('#js-businessOpenBtn');
            self.btnNo = $('#js-businessCloseBtn');
            self.btnActiveClass = 'active';
            self.label = $('#bussid');

            var isBusinessValue = $('#js-isbusiness').val();
            if (isBusinessValue === 'false') {
                self.btnNo.addClass(self.btnActiveClass);
                self.btnYes.removeClass(self.btnActiveClass);
                self.label.removeClass('required');
                self.btnNo.focus(); 
            } else if (isBusinessValue === 'true') {
                self.btnYes.addClass(self.btnActiveClass);
                self.btnNo.removeClass(self.btnActiveClass);
                self.label.addClass('required');
                self.btnYes.focus(); 
            }
    

            self.btnYes.on('click', function () {
                self.yes();
            });

            self.btnNo.on('click', function () {
                self.no();
            });

        },

        yes: function () {
            var self = this;

            self.businessContent = $('#js-allMarketsContent');
            self.btnYes = $('#js-businessOpenBtn');
            self.btnNo = $('#js-businessCloseBtn');
            self.btnActiveClass = 'active';
            self.label = $('#bussid');

            $('#js-isbusiness').prop('value', 'true');
            self.btnYes.addClass(self.btnActiveClass);
            self.btnNo.removeClass(self.btnActiveClass);
            self.label.addClass('required');

        },
        no: function () {
            var self = this;

            self.businessContent = $('#js-allMarketsContent');

            self.btnYes = $('#js-businessOpenBtn');
            self.btnNo = $('#js-businessCloseBtn');
            self.btnActiveClass = 'active';
            self.label = $('#bussid');

            $('#js-isbusiness').prop('value', 'false');
            self.btnNo.addClass(self.btnActiveClass);
            self.btnYes.removeClass(self.btnActiveClass);
            self.label.removeClass('required');
        }
    };
}




//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/registration/allMarketsShowHide.js
// module id = 258
// module chunks = 4